import { AuthenticationService } from "@app/core/services/authentication.service";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { ROUTES } from "@app/shared/constants/routes.constants";

export const HouseGuard = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (!authService.isHouseAccount) {
    router.navigate([ROUTES.LOGIN]);
    return false;
  }

  return true;
};
